/**
 * Caricamento delle route dei prodotti montati su questo host.
 *
 * Ogni prodotto è un chunk separato (import dinamico). Con VITE_PRODUCT impostato in build
 * (app nativa, build dedicate) le condizioni qui sotto diventano costanti e Rollup elimina
 * gli import degli altri prodotti: il loro codice NON finisce nel bundle.
 * Per questo ogni condizione confronta direttamente import.meta.env.VITE_PRODUCT (niente helper).
 */
import type { ProductKey } from "@/platform/products";
import type { ProductRoutesModule } from "./types";

type Loader = (() => Promise<{ default: ProductRoutesModule }>) | null;

const LOADERS: Record<ProductKey, Loader> = {
  console:
    !import.meta.env.VITE_PRODUCT || import.meta.env.VITE_PRODUCT === "console"
      ? () => import("./console/routes")
      : null,
  construction:
    !import.meta.env.VITE_PRODUCT || import.meta.env.VITE_PRODUCT === "construction"
      ? () => import("./construction/routes")
      : null,
  crm:
    !import.meta.env.VITE_PRODUCT || import.meta.env.VITE_PRODUCT === "crm"
      ? () => import("./crm/routes")
      : null,
  billing:
    !import.meta.env.VITE_PRODUCT || import.meta.env.VITE_PRODUCT === "billing"
      ? () => import("./billing/routes")
      : null,
  // Supply: route in arrivo dal branch feature/supply (src/products/supply/routes.tsx)
  supply: null,
};

export async function loadProductRoutes(products: ProductKey[]): Promise<ProductRoutesModule[]> {
  const loaders = products.map((p) => LOADERS[p]).filter((l): l is NonNullable<Loader> => !!l);
  const modules = await Promise.all(loaders.map((load) => load()));
  return modules.map((m) => m.default);
}
